
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"67","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.545 11c.71-.02 2.1.024 2.71-.846.601-.856.473-2.739.42-3.716-.14-1.158-.1-3.515.483-4.26C5.771 1.394 6.352 1.062 7.545 1","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M1.545 11c.71.02 2.1-.024 2.71.846.601.857.473 2.739.42 3.716-.14 1.158-.1 3.514.483 4.26.613.784 1.194 1.116 2.387 1.178","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round"}}),_c('rect',{attrs:{"x":"12.045","y":"5.5","width":"15","height":"11","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}}),_c('path',{attrs:{"d":"M33.545 21V1","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round"}}),_c('rect',{attrs:{"x":"40.045","y":"5.5","width":"15","height":"11","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}}),_c('path',{attrs:{"d":"M65.545 11c-.71-.02-2.099.024-2.71-.846-.6-.856-.472-2.739-.419-3.716.14-1.158.099-3.515-.483-4.26-.613-.784-1.194-1.116-2.388-1.178","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M65.545 11c-.71.02-2.099-.024-2.71.846-.6.857-.472 2.739-.419 3.716.14 1.158.099 3.514-.483 4.26-.613.784-1.194 1.116-2.388 1.178","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    